import Vue from "vue"

export const docTagStore = {
  state: {
    docTag: {},
    docTags: [],
    docTagPagination: {}
  },
  mutations: {
    SET_DOC_TAG_PROPERTY(state, { key, value }) {
      Vue.set(state.docTag, key, value)
    },
    SET_DOC_TAG(state, docTag) {
      Vue.set(state, 'docTag', docTag)
    },
    SET_DOC_TAGS(state, docTags) {
      Vue.set(state, 'docTags', docTags)
    },
    SET_DOC_TAG_PAGINATION(state, docTagPagination) {
      Vue.set(state, 'docTagPagination', docTagPagination)
    }
  },
  // TODO: мож действия тоже  писать заглаными буквами чтобы понимать что мы имеем дело с Vuex?
  actions: {
    getDocTags({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.get('api/v1/doc_tags', { params: params }).then(data => {
          if (data.ok) {
            commit('SET_DOC_TAGS', data.body.doc_tags)
            commit('SET_DOC_TAG_PAGINATION', data.body.pagination)
            resolve(data)
          }
        })
      })
    },
    createDocTag({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.post(`api/v1/doc_tags`, params)
          .then(data => {
            if (data.ok) {
              commit('SET_DOC_TAG', {})
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    },
    updateDocTag({ commit }, { params, docTagId }) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(`api/v1/doc_tags/${docTagId}`, params)
          .then(data => {
            if (data.ok) {
              commit('SET_DOC_TAG', {})
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    },
    deleteDocTag({ commit }, docTagId) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(`api/v1/doc_tags/${docTagId}`)
          .then(data => {
            if (data.ok) {
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    }
  }
}